export default {
    gap: 100,
    pipes: [{
        x: window.innerWidth,
        y: 0
      }],
    pipeDown: './image/pipeDown.png',
    pipeUp: './image/pipeUp.png',
    speed: 2
}